<template>
  <div class="page-container">
    <div class="main">
      <page :url="url" :form="form" @reset="reset" ref="pageRef">
        <template slot="tableSearch">
          <el-form-item :label="$t('text.operationModule')">
            <el-select v-model="form.code"
                       :placeholder="$t('message.chooseOne')"
                       filterable
                       clearable>
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="item in moduleList"
                         :key="item.code"
                         :label="item.display"
                         :value="item.code"/>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.operator')">
            <el-select
                v-model="form.userId"
                filterable
                clearable
                :placeholder="$t('message.chooseOne')"
                popper-class="eloption"
            >
              <el-option :label="$t('option.all')" value="" />
              <el-option
                  v-for="user in userList"
                  :label="user.value + '-' + user.name"
                  :key="user.value"
                  :value="user.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('text.keywords')">
            <el-input
                style="width: 300px"
                v-model="form.keyword"
                :placeholder="$t('message.input')"
                maxlength="40"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('text.creationTime')"
                        prop="createTimeDate"
                        :inline-message="true"
                        :error="showCreateTimeDateError">
            <el-date-picker v-model="createTimeDate"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyyMMdd"
                            :range-separator="$t('text.to')"
                            :start-placeholder="$t('text.startDate')"
                            :end-placeholder="$t('text.endDate')"
                            @change="createTimeChange"/>
          </el-form-item>
        </template>
        <template slot="tableColumn">
          <el-table-column
              prop="logId"
              width="100px"
              :label="$t('text.number')"
              align="center"/>
          <el-table-column
              prop="loginName"
              width="100px"
              :label="$t('text.operator')"
              align="center"/>
          <el-table-column
              prop="menuPath"
              width="250px"
              :label="$t('text.operationModule')"
              align="center"/>
          <el-table-column
              prop="content"
              width="800px"
              :label="$t('text.operationContent')"
              align="center"
          >
            <template slot-scope="{ row }">
              <div v-if="row.content">
                <el-popover v-if="row.content.length > 127"
                            placement="top-start"
                            trigger="hover">
                  <pre>{{ row.content }}</pre>
                  <div slot="reference" class="remark">
                    {{ row.content }}
                  </div>
                </el-popover>
                <div v-else>{{ row.content }}</div>
              </div>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
              prop="ipAddress"
              width="300px"
              :label="$t('text.ipAddress')"
              align="center"/>
          <el-table-column
              prop="createDate"
              width="200px"
              :label="$t('text.operationTime')"
              align="center">
            <template slot-scope="{ row }">
              {{ $formatter.formatDate(null, null, row.createDate + row.createTime, null) }}
            </template>
          </el-table-column>
        </template>
      </page>
    </div>
  </div>
</template>
<script>

import Page from "@/components/Page.vue";
import loading from "element-ui/packages/loading";
import moment from "moment";


export default {
  computed: {
    loading() {
      return loading
    }
  },
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/audit-log/selectList",
      createTimeDate: null,
      showCreateTimeDateError: "",
      form: {
        code: "",
        userId: "",
        startCreateDate: "",
        endCreateDate: "",
        keyword:"",
      },
      formRules: {
        createTimeDate: [
          {
            type: "date",
            trigger: "change",
            validator: this.validateDate
          }
        ]
      },
      moduleList: [],
      userList: []
    };
  },
  methods: {
    createTimeChange(e) {
      if (e) {
        this.form.startCreateDate = e[0];
        this.form.endCreateDate = e[1];
      } else {
        this.form.startCreateDate = "";
        this.form.endCreateDate = "";
      }
    },
    reset() {
      let start = moment().subtract(2, "days").format("yyyyMMDD");
      let end = moment().format("yyyyMMDD");
      this.form.startCreateDate = start;
      this.form.endCreateDate = end;
      this.createTimeDate = [start, end];
      this.userId = "";
      this.keyword = "";
    },
    validateDate() {
      if (!this.createTimeDate) {
        this.showCreateTimeDateError = this.$t('message.creationTimeOrFinishTimeRequiredError');
      } else {
        this.showCreateTimeDateError = "";
      }
    }
  },
  created() {
    this.reset();

    this.$axios
        .get("/audit-log/selectOption", {params: {}})
        .then((res) => {
          this.moduleList = res.data;
        });

    this.$axios
        .get("/sysUserInfo/selectListForOption", { params: {} })
        .then((res) => {
          this.userList = res.data;
        });
  }
};
</script>

<style scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-popover pre {
  max-width: 750px;
  max-height: 500px;
  overflow: auto;
  white-space: pre-wrap;
}
</style>